module.exports = __webpack_public_path__ + "static/Palette_panel-452eb66a5b69fc087aa91059f4d365d9.png";